import { BaseComponent } from '../base-component'
import { CartPage } from '../../sections/cart/cart'
import { CartDrawer } from '../../sections/cart-drawer/cart-drawer'
import { replaceNodeChildren } from '../../utils/dom'
import { $el } from 'src/scripts/utils/utils'

const CART_PAGE_SELECTOR = 'cart-page'
const CART_DRAWER_SELECTOR = 'cart-drawer'
const NEW_COUNT_SELECTOR = `#NewCartCount`

export class CartCount extends BaseComponent {
  mountComponent(): void {
    const cart: CartPage = $el(CART_PAGE_SELECTOR)
    const cartDrawer: CartDrawer = $el(CART_DRAWER_SELECTOR)
    cart?.on('update-nodes', this.handleCartUpdate)
    cartDrawer?.on('update-nodes', this.handleCartUpdate)
  }

  unmountComponent(): void {
    const cart: CartPage = $el(CART_PAGE_SELECTOR)
    const cartDrawer: CartDrawer = $el(CART_DRAWER_SELECTOR)
    cart?.off('update-nodes', this.handleCartUpdate)
    cartDrawer?.off('update-nodes', this.handleCartUpdate)
  }

  handleCartUpdate = ({ node }): void => {
    const newNode = $el(NEW_COUNT_SELECTOR, node)
    replaceNodeChildren(this, newNode)
  }
}
